import React, { useState, useEffect } from "react";
import { Card, CardContent, Button } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

// Lottery Data with unique styles
const lotteryData = [
    {
        id: 1,
        prize: "40 Lakhs",
        days: 16,
        hours: 0,
        minutes: 16,
        seconds: 18,
        ticketName: "Rajshree 80",
        date: "11.12.2025",
        time: "6:30 PM",
        ticketPrice: 80,
        prizeText: "linear-gradient(to right, #f43f5e, #f59e0b, #3b82f6)",
        buttonBg: "#f43f5e",
    },
    {
        id: 2,
        prize: "25 Lakhs",
        days: 10,
        hours: 5,
        minutes: 30,
        seconds: 0,
        ticketName: "Lucky Star",
        date: "15.12.2025",
        time: "7:00 PM",
        ticketPrice: 50,
        prizeText: "linear-gradient(to right, #ec4899, #f97316, #3b82f6)",
        buttonBg: "#ec4899",
    },
    {
        id: 3,
        prize: "50 Lakhs",
        days: 20,
        hours: 12,
        minutes: 45,
        seconds: 30,
        ticketName: "Super Win",
        date: "20.12.2025",
        time: "5:00 PM",
        ticketPrice: 100,
        prizeText: "linear-gradient(to right, #10b981, #3b82f6, #f43f5e)",
        buttonBg: "#10b981",
    },
    {
        id: 4,
        prize: "10 Lakhs",
        days: 5,
        hours: 8,
        minutes: 15,
        seconds: 10,
        ticketName: "Mega Lucky",
        date: "25.12.2025",
        time: "8:00 PM",
        ticketPrice: 20,
        prizeText: "linear-gradient(to right, #9333ea, #facc15, #3b82f6)",
        buttonBg: "#9333ea",
    },
];

const LotteryCard = ({ data }) => {
    const navigate = useNavigate();

    const [timeLeft, setTimeLeft] = useState({
        days: data.days,
        hours: data.hours,
        minutes: data.minutes,
        seconds: data.seconds,
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                let { days, hours, minutes, seconds } = prev;
                if (seconds > 0) seconds--;
                else {
                    seconds = 59;
                    if (minutes > 0) minutes--;
                    else {
                        minutes = 59;
                        if (hours > 0) hours--;
                        else {
                            hours = 23;
                            if (days > 0) days--;
                            else return { days: 0, hours: 0, minutes: 0, seconds: 0 };
                        }
                    }
                }
                return { days, hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>    <Card
            className="lottery-card"
            style={{ background: data.cardBg, borderRadius: 20, overflow: "hidden" }}
        >
            <CardContent>
                <div className="prize-section">
                    <div className="shimmer"></div>
                    <h6 style={{ color: "#f31212ff" }}>Win First Prize</h6>
                    <div className="prize-amount">
                        <CurrencyRupeeIcon style={{ color: "#181717ff", fontSize: 36 }} />
                        <h2
                            className="prize-text"
                            style={{
                                background: data.prizeText,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                fontSize: 32,
                                fontWeight: "bold",
                                marginLeft: 8,
                            }}
                        >
                            {data.prize}
                        </h2>
                    </div>
                </div>

                <div className="countdown" style={{ textAlign: "center", margin: "15px 0" }}>
                    <p style={{ fontSize: 20 }}>
                        {String(timeLeft.days).padStart(2, "0")} : {String(timeLeft.hours).padStart(2, "0")} :{" "}
                        {String(timeLeft.minutes).padStart(2, "0")} : {String(timeLeft.seconds).padStart(2, "0")}
                    </p>
                    <p>Days Hrs Mins Secs</p>
                </div>

                <div className="ticket-info" style={{ color: "#fff", marginBottom: 15 }}>
                    <p style={{ fontWeight: 600 }}>{data.ticketName}</p>
                    <div className="info-details" style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
                        <p>Date: {data.date}</p>
                        <p>Time: {data.time}</p>
                    </div>
                </div>

                <div className="ticket-price" style={{ textAlign: "center", marginBottom: 15 }}>
                    <h4>Ticket Price: ₹{data.ticketPrice}</h4>
                </div>

                <Button
                    fullWidth
                    style={{
                        backgroundColor: data.buttonBg,
                        color: "#fff",
                        fontWeight: "bold",
                        padding: "10px",
                        borderRadius: 50,
                        boxShadow: "0 6px 10px rgba(0,0,0,0.3)",
                    }}
                    onClick={() => navigate("/ticket-select")}
                >
                    Buy Now
                </Button>
            </CardContent>
        </Card>
        </>

    );
};

const UpcomingLotteriesSlider = () => {

    return (
        <div className=" container-fluid ticket-grid-container1 ">
            <h2 className="ticket-title"> Upcoming Attractions</h2>
            
            <div className="row">
                <div className="col-lg-12 d-flex ac-jc ">

                    <Swiper
                        modules={[Autoplay, Navigation, Pagination]}
                        slidesPerView={1}
                        spaceBetween={20}
                        loop={true}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        navigation
                        pagination={{ clickable: true }}
                        breakpoints={{
                            640: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                        }}
                        className="lottery-swiper"
                    >
                        {lotteryData.map(lottery => (
                            <SwiperSlide key={lottery.id}>
                                <LotteryCard data={lottery} />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>
            </div>
        </div>
    );
};


export default UpcomingLotteriesSlider;
